export const cards = [
  {
    titulo: 'Prerrequisitos',
    completo: false
  },
  {
    titulo: 'Fecha de lanzamiento',
    completo: false
  },
  {
    titulo: 'Recordatorios',
    opcional: true
  },
  {
    titulo: 'Mensajes de comunicación',
    opcional: true
  },
];

export const secciones = [
  {
    id: 'encuesta',
    titulo: 'Encuesta',
    proceso: 'Creando encuesta',
    error: 'Ocurrió un error al crear la encuesta, vuelva a intentar el proceso',
    icono: 'insert_drive_file',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'usuarios',
    titulo: 'Usuarios',
    proceso: 'Agregando usuarios a la encuesta',
    error: 'Ocurrió un error al agregar los usuarios, vuelva a intentar el proceso',
    icono: 'people',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'NPS',
    titulo: 'NPS',
    proceso: 'Agregando NPS a la encuesta',
    error: 'Ocurrió un error al agregar NPS, vuelva a intentar el proceso',
    icono: 'face',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Reactivos',
    titulo: 'Reactivos',
    proceso: 'Agregando reactivos a la encuesta',
    error: 'Ocurrió un error al agregar los reactivos, vuelva a intentar el proceso',
    icono: 'sentiment_satisfied_alt',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Control',
    titulo: 'Pregunta de control',
    proceso: 'Agregando pregunta de control a la encuesta',
    error: 'Ocurrió un error al agregar la pregunta de control, vuelva a intentar el proceso',
    icono: 'control_camera',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Demograficos',
    titulo: 'Demográficos',
    proceso: 'Agregando demográficos a la encuesta',
    error: 'Ocurrió un error al agregar los demográficos, vuelva a intentar el proceso',
    icono: 'poll',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Abiertas',
    titulo: 'Preguntas abiertas',
    proceso: 'Agregando preguntas abiertas a la encuesta',
    error: 'Ocurrió un error al agregar las preguntas abiertas, vuelva a intentar el proceso',
    icono: 'help_outline',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Forall',
    titulo: 'ForAll',
    proceso: 'Agregando prácticas ForAll a la encuesta',
    error: 'Ocurrió un error al agregar las prácticas ForAll, vuelva a intentar el proceso',
    icono: 'format_list_numbered',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Adicionales',
    titulo: 'Adicionales',
    proceso: 'Agregando preguntas adicionales a la encuesta',
    error: 'Ocurrió un error al agregar las preguntas adicionales, vuelva a intentar el proceso',
    icono: 'note_add',
    visible: true,
    completo: false,
    fallo: false
  },
];

export const tipoCorreos = [
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO1.TITULO',
    activo: false,
    tipoCorreo: 99
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO2.TITULO',
    activo: false,
    tipoCorreo: 1,
    description:'SHEDULE2_0.CORREOS.TIPO2.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO3.TITULO',
    activo: false,
    tipoCorreo: 2,
    description:'SHEDULE2_0.CORREOS.TIPO3.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO4.TITULO',
    activo: false,
    tipoCorreo: 3,
    description:'SHEDULE2_0.CORREOS.TIPO4.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO5.TITULO',
    activo: false,
    tipoCorreo: 4,
    description:'SHEDULE2_0.CORREOS.TIPO5.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO6.TITULO',
    activo: false,
    tipoCorreo: 5,
    description:'SHEDULE2_0.CORREOS.TIPO6.INFO',
  },
  { //Prueba
    titulo: 'SHEDULE2_0.CORREOS.TIPO7.TITULO',
    activo: false,
    tipoCorreo: 6,
    description:'SHEDULE2_0.CORREOS.TIPO7.INFO',

  },{
    titulo: 'SHEDULE2_0.CORREOS.TIPO8.TITULO',
    activo: false,
    tipoCorreo: 7,
    description:'SHEDULE2_0.CORREOS.TIPO8.INFO',
  },

];

export const tipoCorreosNorma = [
  {
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO1.TITULO',
    tipoCorreo: 1,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO1.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO2.TITULO',
    tipoCorreo: 2,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO2.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO3.TITULO',
    tipoCorreo: 3,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO3.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO4.TITULO',
    tipoCorreo: 4,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO4.INFO',
  },
  {
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO5.TITULO',
    tipoCorreo: 5,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO5.INFO',
  },{ //Prueba
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO6.TITULO',
    tipoCorreo: 6,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO6.INFO',
  },
  { //Recordatorio
    titulo: 'SHEDULE2_0.CORREOS_NORM.TIPO7.TITULO',
    tipoCorreo: 7,
    activo: false,
    description:'SHEDULE2_0.CORREOS_NORM.TIPO7.INFO',
  },
];
